import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Paper, Avatar, ToggleButton, ToggleButtonGroup, CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import useApiManager from '../../utils/Api/apiManager';
import { useNavigate } from "react-router-dom";
import Drawer from '../../components/Campaigns/Details/Drawer';
import BasicDetails from '../../components/Campaigns/Details/BasicDetails/BasicDetails';
import FullDetails from '../../components/Campaigns/Details/FullDetails/FullDetails';
import Leads from '../../components/Campaigns/Details/Leads/Leads'
import Contacts from '../../components/Campaigns/Details/Contacts/Contacts';
import CampaignTwoToneIcon from '@mui/icons-material/CampaignTwoTone';
import Notes from '../../components/Common/Notes/Notes';
import Attachments from '../../components/Common/Attachments/Attachments'
import Deals from '../../components/Campaigns/Details/Deals/Deals';

const CampaignDetails = () => {
    const { campaignId } = useParams(); // Get campaignID from URL
    const [campaignDetails, setCampaignDetails] = useState(null);
    const [campaignRelatedEntitiesCount, setCampaignRelatedEntitiesCount] = useState(null);
    const [notes, setNotes] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [campaignContacts, setCampaignContacts] = useState(null);
    const [campaignLeads, setCampaignLeads] = useState(null);
    const [campaignDeals, setCampaignDeals] = useState(null);
    const detailsRef = useRef(null);
    const notesRef = useRef(null);
    const attachmentsRef = useRef(null);
    const leadsRef = useRef(null);
    const contactsRef = useRef(null);
    const dealsRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const { get } = useApiManager();

    const scrollToSection = (ref) => {
        ref.current.scrollIntoView({ behavior: 'smooth' });
    };

    const fetchCampaignDetails = async () => {
        setLoading(true);

        try {
            const data = await get(`/campaigns/${campaignId}`);
            setCampaignDetails(data);
            const campaignName = data.campaignName ?? '';
            document.title = `${campaignName} (Campaign) - iLead CRM`.trim() || 'Campaign Details';
        } catch (error) {
            console.error('Error fetching campaign details:', error);
        } finally {
            setLoading(false);
        }
    };

     const fetchCampaignRelatedEntitiesCount = async () => {
        setLoading(true);

        try {
            const data = await get(`/campaigns/${campaignId}/related-entities-count`);
            setCampaignRelatedEntitiesCount(data);
        } catch (error) {
            console.error('Error fetching campaign related entities count:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchNotes = async () => {
        setLoading(true);

        try {
            const notes = await get(`/campaigns/${campaignId}/notes`);
            setNotes(notes);
        } catch (error) {
            console.error('Error fetching campaign notes:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchAttachments = async () => {
        setLoading(true);

        try {
            const attachments = await get(`/campaigns/${campaignId}/attachments`);
            setAttachments(attachments);
        } catch (error) {
            console.error('Error fetching campaign attachments:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchCampaignLeads = async () => {
        setLoading(true);

        try {
            const data = await get(`/campaigns/${campaignId}/leads`);
            setCampaignLeads(data);
        } catch (error) {
            console.error('Error fetching campaign leads:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchCampaignContacts = async () => {
        setLoading(true);

        try {
            const data = await get(`/campaigns/${campaignId}/contacts`);
            setCampaignContacts(data);
        } catch (error) {
            console.error('Error fetching campaign contacts:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchCampaignDeals = async () => {
        setLoading(true);

        try {
            const data = await get(`/campaigns/${campaignId}/deals`);
            setCampaignDeals(data);
        } catch (error) {
            console.error('Error fetching campaign deals:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCampaignDetails();
        fetchCampaignRelatedEntitiesCount();
        fetchNotes();
        fetchAttachments();
        fetchCampaignLeads();
        fetchCampaignContacts();
        fetchCampaignDeals();
    }, []);

    return (
        <div style={{}}>
            <Paper elevation={0} sx={{
                p: 2
            }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CampaignTwoToneIcon />
                        <h3> {loading ? "Loading..." : (campaignDetails?.campaignName || '')}  </h3>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1 }}>

                        <Link to={`/campaigns/edit/${campaignId}`}>
                            <Button variant="outlined">Edit</Button>
                        </Link>

                    </Box>
                </Box>
            </Paper >
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Box id='drawer' sx={{ display: 'flex' }}>
                    <Drawer
                        scrollToSection={scrollToSection}
                        sections={{
                            detailsRef,
                            notesRef,
                            attachmentsRef,
                            leadsRef,
                            contactsRef,
                            dealsRef
                        }} />
                </Box>
                <Box id='main' sx={{ flexGrow: 1, paddingTop: 3, paddingRight: 5 }}>
                    {/* <ToggleButtonGroup
                        color="primary"
                        exclusive
                        aria-label="Platform"
                        sx={{ marginBottom: 3 }}
                    >
                        <ToggleButton value="overview">Overview</ToggleButton>
                        <ToggleButton value="history">History</ToggleButton>
                    </ToggleButtonGroup> */}
                    <Box sx={{ '& > * > *': { marginBottom: 3 } }}>

                        <div id='overview'>
                            <div>
                                {/* <BasicDetails data={leadDetails} /> */}
                                <BasicDetails data={campaignDetails}/>
                            </div>
                           
                            <div ref={detailsRef}>
                                <FullDetails data={campaignDetails} />
                            </div>
                            <div ref={notesRef}>
                                <Notes data={notes} fetchNotes={fetchNotes} entity={'campaigns'} />
                            </div>
                            <div ref={attachmentsRef}>
                                <Attachments data={attachments} fetchAttachments={fetchAttachments} entity={'campaigns'}/>
                            </div>
                            <div ref={leadsRef}>
                                <Leads data={campaignLeads} campaignId={campaignId} fetchLeads={fetchCampaignLeads} leadsCount={campaignRelatedEntitiesCount?.leadsCount} fetchCampaignRelatedEntitiesCount={fetchCampaignRelatedEntitiesCount} />
                            </div>
                            <div ref={contactsRef}>
                                <Contacts data={campaignContacts} campaignId={campaignId} fetchContacts={fetchCampaignContacts} contactsCount={campaignRelatedEntitiesCount?.contactsCount} fetchCampaignRelatedEntitiesCount={fetchCampaignRelatedEntitiesCount} />
                            </div>
                            <div ref={dealsRef}>
                                <Deals data={campaignDeals} campaignId={campaignId} fetchDeals={fetchCampaignDeals} dealsCount={campaignRelatedEntitiesCount?.dealsCount} fetchCampaignRelatedEntitiesCount={fetchCampaignRelatedEntitiesCount} />
                            </div>
                        </div>
                        <div id='history'></div>
                    </Box>
                </Box>
            </Box>

        </div>
    )
};

export default CampaignDetails;